require('./taxAndRentsPaymentWithDraftView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');
// @ actions
const taxAndRentsPaymentWithDraftActions = require('actions/taxAndRentsPaymentWithDraft');
// @ components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const PaymentWithDraftStep1 = require('components/taxAndRents/paymentWithDraftSteps/paymentWithDraftStep1/paymentWithDraftStep1');
const PaymentWithDraftStep2 = require('components/taxAndRents/paymentWithDraftSteps/paymentWithDraftStep2/paymentWithDraftStep2');
const PaymentWithDraftSuccessStep = require('components/taxAndRents/paymentWithDraftSteps/paymentWithDraftSuccessStep/paymentWithDraftSuccessStep');
const PaymentWithDraftErrorStep = require('components/taxAndRents/paymentWithDraftSteps/paymentWithDraftErrorStep/paymentWithDraftErrorStep');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
// @ constants
const { DECLARATION_RESULT_TO_PAY, GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');
//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

class TaxAndRentsPaymentWithDraftView extends React.Component {
    constructor(props) {
        super(props);

        this.buildWizard = this.buildWizard.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    buildSuccessful() {
        const { immTaxAndRentsPaymentWithDraft, immAccounts } = this.props;

        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <PaymentWithDraftSuccessStep
                        immAccounts={immAccounts}
                        immTaxAndRentsPaymentWithDraft={immTaxAndRentsPaymentWithDraft}
                    />
                </div>
            </div>
        )
    }

    buildWizard() {
        const {
            handleFinish,
            immAccounts,
            immFlagBasedFeatures,
            immLogin,
            immProfile,
            immTaxAndRentsPaymentWithDraft,
            setAccount,
            setAmountToReturn,
            setDecalarationResult,
            setDifferentialFee,
            setDomiciliateSecondPayment,
            setFractionPayment,
            setJustificative,
            setVisibleStep,
            setWillCancel,
            validateStep,
        } = this.props;
        const immSteps = immTaxAndRentsPaymentWithDraft.get('steps');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: handleFinish,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immTaxAndRentsPaymentWithDraft.get('visibleStep')}
                showPreLeaveModal={true}
            >
                <WizardStep position="first" cancelButton={true} nextButton={true} >
                    <PaymentWithDraftStep1
                        immProfile={immProfile}
                        immLogin={immLogin}
                        immAccounts={immAccounts}
                        immTaxAndRentsPaymentWithDraft={immTaxAndRentsPaymentWithDraft}
                        isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                        setJustificative={setJustificative}
                        setDecalarationResult={setDecalarationResult}
                        setAmountToReturn={setAmountToReturn}
                        setAccount={setAccount}
                        setDomiciliateSecondPayment={setDomiciliateSecondPayment}
                        setDifferentialFee={setDifferentialFee}
                        setFractionPayment={setFractionPayment}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton="common-confirm"
                    addLoadingBehaviour={true}
                    previousButton={true}
                    finishButton={true}
                >
                    <PaymentWithDraftStep2
                        immProfile={immProfile}
                        immLogin={immLogin}
                        immAccounts={immAccounts}
                        immTaxAndRentsPaymentWithDraft={immTaxAndRentsPaymentWithDraft}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    handleCancel() {
        this.props.history.push('/myprofile/taxAndRents');
    }

    render() {
        const { immAccounts, immTaxAndRentsPaymentWithDraft } = this.props;
        const title = formatText('breadcrumb-taxAndRentsPaymentWithDraft');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-rent'),
                url: '/myprofile/taxAndRents'
            },
            {
                text: title
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-profileTaxAndRentsTitle')}
            />
        );
        const allAccountsInactive = hasAllAccountsInactive(
            immAccounts.get('byOrder'),
            immAccounts.get('byId')
        );
        const immStep = immTaxAndRentsPaymentWithDraft.getIn(['steps', 0]);
        const isDeclarationToPay = immStep && immStep.get('declarationResult') === DECLARATION_RESULT_TO_PAY

        let bodyContent;

        if (allAccountsInactive && isDeclarationToPay) {
            bodyContent = (<InactiveAccountsError
                navigateToBackButtonText={'taxAndRents'}
                navigateToBackButtonURL={'taxAndRents'}
            />);
        }
        else if (immTaxAndRentsPaymentWithDraft.get('submitSuccessful')) {
            bodyContent = this.buildSuccessful();
        } else if (!!immTaxAndRentsPaymentWithDraft.get('error')) {
            bodyContent = <PaymentWithDraftErrorStep />;
        } else {
            const wizard = this.buildWizard();

            bodyContent = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8 col-xs-offset-2">
                        {wizard}
                    </div>
                </div>
            );
        }

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle(title)}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyContent}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

TaxAndRentsPaymentWithDraftView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immLogin: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immTaxAndRentsPaymentWithDraft: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setAmountToReturn: PropTypes.func.isRequired,
    setJustificative: PropTypes.func.isRequired,
    setDecalarationResult: PropTypes.func.isRequired,
    setDomiciliateSecondPayment: PropTypes.func,
    setDifferentialFee: PropTypes.func,
    setFractionPayment: PropTypes.func,
    consultPaymentsDebits: PropTypes.func
};

module.exports.constructor = TaxAndRentsPaymentWithDraftView;
module.exports.TaxAndRentsPaymentWithDraftView = connect(
    state => ({
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immLogin: state.okLogin,
        immProfile: state.profile,
        immTaxAndRentsPaymentWithDraft: state.taxAndRentsPaymentWithDraft,
    }), {
    validateStep: taxAndRentsPaymentWithDraftActions.validateStep,
    setVisibleStep: taxAndRentsPaymentWithDraftActions.setVisibleStep,
    setWillCancel: taxAndRentsPaymentWithDraftActions.setWillCancel,
    handleFinish: taxAndRentsPaymentWithDraftActions.postPaymentWithDraft,
    clearRequest: taxAndRentsPaymentWithDraftActions.clearRequest,
    setJustificative: taxAndRentsPaymentWithDraftActions.setJustificative,
    setAccount: taxAndRentsPaymentWithDraftActions.setAccount,
    setAmountToReturn: taxAndRentsPaymentWithDraftActions.setAmountToReturn,
    setDecalarationResult: taxAndRentsPaymentWithDraftActions.setDecalarationResult,
    setDomiciliateSecondPayment: taxAndRentsPaymentWithDraftActions.setDomiciliateSecondPayment,
    setDifferentialFee: taxAndRentsPaymentWithDraftActions.setDifferentialFee,
    setFractionPayment: taxAndRentsPaymentWithDraftActions.setFractionPayment,
})(withRouter(TaxAndRentsPaymentWithDraftView));
